import { useUser } from 'hooks/useUser';

export const useAccountEmail = () => {
  const user = useUser();

  if (user && user.accountInfo) {
    return user.accountInfo.email;
  }
};
